<template>
  <CursorPulseCircle :elementBlacklistIds="['dashboard_learnMoreBtn']">
    <template #default>
      <div
        class="cntb font-poppins"
        style="--clr-primary: var(--clr-primary-brand)"
      >
        <div
          class="cntb_inner f-column"
          style="padding: 1rem clamp(1px, 4rem, 12vw); overflow: hidden"
        >
          <!-- <div
        class="cntb_tag clr-black text-nowrap weight_700"
        style="background: var(--clr-white-0); z-index: 4"
      >
        NEW
      </div> -->
          <div
            class="cntb_inner_back"
            style="z-index: 1"
          ></div>
          <div
            class="d-flex py-2 flex-wrap f-column"
            style="position: relative; z-index: 6; gap: 1.85rem"
          >
            <div
              class="f-column f-wrap font-poppins"
              style="gap: 0rem"
            >
              <span style="font-size: 2rem; font-weight: 450"
                ><span>We Just Added </span
                ><span class="clr-primary">7,000 New FT ICM Sims!</span></span
              >
              <span
                class="weight_400"
                style="font-size: 1.3rem; font-weight: 400; color: #b3b3b8"
                >Prepare for the most crucial moments of your tournaments.</span
              >
              <span
                class="weight_400"
                style="font-size: 1.3rem; font-weight: 400; color: #b3b3b8"
                >Just in time for the SCOOP, WSOP, WCOOP season.</span
              >
            </div>

            <div
              style="position: relative"
              class="f-column f-center mr-auto"
            >
              <a
                id="dashboard_learnMoreBtn"
                style="
                  --radius: 0.7rem;
                  color: var(--clr-black-0) !important;
                  font-weight: 600;
                  padding: 21px 21px !important;
                "
                class="gw_btn gw_btn_primary cntb_message_btn weight_500 clr-white text-h7 py-8 px-10"
                href="https://blog.gtowizard.com/final-table-icm-just-leveled-up/"
                target="_blank"
              >
                Learn more
              </a>
              <!-- </a>
              <router-link
                id="dashboard_learnMoreBtn"
                style="--radius: 1rem; color: var(--clr-black-0) !important; font-weight: 700"
                :to="{ name: 'Play', query: { utm_source: 'banner' } }"
                class="gw_btn gw_btn_primary cntb_message_btn weight_500 clr-white"
                :class="!mobile ? 'text-h5 py-8 px-10' : 'text-large mx-0 py-6 mb-2 w-100'"
              >
                <div
                  class="mdi mdi-cards-playing mr-2"
                  style="font-size: 1.25em"
                ></div>
                {{ $t('btn.play_now') }}
              </router-link> -->
            </div>
          </div>
        </div>
      </div>
    </template>
  </CursorPulseCircle>
</template>

<script>
import CursorPulseCircle from '@/components/lib/CursorPulseCircle.vue'
import PulseCircle from '../lib/PulseCircle.vue'
import Countdown from './Countdown.vue'

export default {
  name: 'DashboardBanner',
  // mixins: [links_mix, tier_mix],
  components: {
    CursorPulseCircle,
    Countdown,
  },
  data() {
    return {}
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/earlybird/${img}`, import.meta.url).href
    },
  },
  computed: {
    isDev() {
      return import.meta.env.VITE_ENV !== 'production'
    },
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
    isUserPremiumMTT() {
      return this.$store.getters.user_info.subs.some(
        i => i.plan.type === 'MTT' && (i.plan.tier === 'PREMIUM' || i.plan.tier === 'ELITE'),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.svg-holder {
  z-index: 1;
  position: absolute;
  right: 2%;
  top: -124%;
  height: 33rem;
  svg {
    width: 100%;
    height: 100%;
  }
}

.cntb_tag {
  position: absolute;
  z-index: 1;
  top: 0.8rem;
  left: -3.2rem;
  font-size: 1rem;
  padding: 0.4rem 4rem;
  text-align: center;
  transform: rotate(-45deg);
  font-weight: 700;
}
.banner-link-text {
  color: var(--clr-white) !important;
  transition: all 0.3s ease;
}
.cntb {
  position: relative;
  background: #1d1d1d;
  width: 100%;
  flex-shrink: 0;
  border-radius: 8px;
  // overflow: hidden;
  &_inner {
    // overflow: hidden;
    border-radius: 8px;
    background: var(--clr-black-0);
    border: solid var(--clr-black-1) 1px;
    // &::before {
    //   content: '';
    //   position: absolute;
    //   height: 100%;
    //   width: 100%;
    //   left: 0;
    //   top: 0;
    //   z-index: 2;
    //   --opacity: 0.4;
    //   // --back-from: rgba(18, 18, 18, var(--opacity));
    //   // --back-from: rgba(0, 172, 141, 0.05);
    //   // --back-from: rgba(0, 172, 141, 1);
    //   --back-from: rgba(0, 0, 0, 0.75);
    //   // --back-from: rgba(0, 172, 141, 0.1);
    //   // --back-from: rgba(0, 0, 0, 1);
    //   // --back-from: rgba(0, 33, 47, 0.6);
    //   --back-to: transparent;
    //   overflow: hidden;

    //   border-radius: 8px;
    //   //background: linear-gradient(to left, var(--back-to), var(--back-from));
    // }
    &_back {
      z-index: 0;
      position: absolute;
      height: 100%;
      width: 100%;
      // width: 100%;
      // top: 0;
      left: 0%;
      // left: 0;
      z-index: -1;
      // background: url('@/assets/img/drills_management_new_blockers_score_without_overlay.webp');
      //background: url('@/assets/img/app_banner_image.webp');
      // background: url('@/assets/img/app_banner_preview_play.webp');
      //background: url('@/assets/img/app_banner_preview_matchmaking.webp');
      // background: url('@/assets/img/app_bannerx2.webp');
      // background: url('@/assets/img/world_pro.webp');
      // background: url('@/assets/img/app_banner_new_interface.webp');
      // background: url('@/assets/img/fairplay.webp');
      // background: url('@/assets/img/rakebanner.webp');
      // background: url('@/assets/img/app_banner_wrapup2023.webp');
      // background: url('@/assets/img/app_banner_5.webp');
      background: url('@/assets/img/app_banner_final_tables_icm.webp');
      background-repeat: no-repeat;
      background-size: cover;
      // overflow: hidden;
      border-radius: 8px;
    }
    position: relative;
    display: flex;
    // min-height: 10rem;
    flex-shrink: 0;
    justify-content: center;
    z-index: 4;
  }
  &_img {
    width: 25%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    // img {
    //   position: absolute;
    //   height: 13.5rem;
    //   bottom: -1.5rem;
    // }
  }
  &_message {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 1.75rem;
    font-weight: 700;
    width: 37.5%;
    padding: 0 2rem 0 1rem;
    // padding: 0 1rem 0 1rem;
    line-height: 1.3;
    &_btn {
      min-width: 7.5rem;
    }
  }
}
@media (max-width: 1024px) {
  .cntb_inner_back {
    background-position-x: 50%;
  }
  //.cntb_message_btn {
  //  width: 16rem !important;
  //  margin: 0 auto !important;
  //}
}

// @media (max-width: 768px) {
//   .img-avatar-box {
//     margin-left: -1.75rem;
//   }
//   .cntb_inner_back {
//     &::before {
//       background: linear-gradient(25deg, var(--back-from), var(--back-to) 444%);
//     }
//     background: url('@/assets/img/app_banner_preview_play.webp') no-repeat;
//     background-size: cover;
//     background-position-x: 0;
//   }
// }
@media (max-width: 500px) {
  .svg-holder {
    right: 2%;
    top: -50%;
    height: 33rem;
  }
  .cntb_inner_back {
    background-position-x: 50%;
  }
}
</style>
